export default __webpack_public_path__ + "static/media/logoMovie.0eabbf17.png";